import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createCommentOrReply, fetchTicketDetailsWithReplies } from '../../core/data/redux/tickets/ticketDetail/ticketDetailActions';
import CommonSelect from "../../core/common/commonSelect";
import { AppDispatch } from '../../core/data/redux/store';
import { getEmployeeByUserId } from '../../core/data/redux/employee/employeeAction';
import { fetchTicketById } from '../../core/data/redux/tickets/ticket/ticketActions';

interface ModalProps {
  isOpen: boolean;
  closeModal: () => void;
  ticketId: string | undefined;
  parentId: number | null;
}

const CommentReplyModal: React.FC<ModalProps> = ({ isOpen, closeModal, ticketId, parentId }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: any) => state.auth);
  const { employeesbyUser } = useSelector((state: any) => state.employee);

  const [comment, setComment] = useState('');

  useEffect(() => {
    if (!employeesbyUser?.employeeId) {
      dispatch(getEmployeeByUserId({ userId: user?.UserId }));
    }
  }, [dispatch]);

  const handleSubmit = async () => {
    const data = {
      TicketId: ticketId,
      Response: comment,
      ResponseBy: employeesbyUser?.employeeId,
      CreatedBy: user?.UserId,
      ParentId: parentId,
    };

    try {
      await dispatch(createCommentOrReply(data));
      if (ticketId) {
        await dispatch(fetchTicketById(ticketId))
        await dispatch(fetchTicketDetailsWithReplies(ticketId))
      }
      setComment(''); 
      closeModal();
    } catch (error) {
      console.error('Error creating comment/reply', error);
    }
  };

  return (
    isOpen ? (
      <div className="modal fade show" style={{ display: 'block' }} tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">Add a Comment/Reply</h5>
              <button type="button" className="close" onClick={closeModal} aria-label="Close" style={{ fontSize: '1.5rem', padding: '0.5rem' }}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Comment/Reply</label>
                <textarea
                  className="form-control"
                  rows={5}
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary me-2" onClick={closeModal}>Close</button>
              <button type="button" className="btn btn-primary" onClick={handleSubmit}>Submit</button>
            </div>
          </div>
        </div>
      </div>
    ) : null
  );
};

export default CommentReplyModal;
